import { render, staticRenderFns } from "./qualificationMaterials.vue?vue&type=template&id=d4a63560&scoped=true"
import script from "./qualificationMaterials.vue?vue&type=script&lang=js"
export * from "./qualificationMaterials.vue?vue&type=script&lang=js"
import style0 from "./qualificationMaterials.vue?vue&type=style&index=0&id=d4a63560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a63560",
  null
  
)

export default component.exports